import styled from 'styled-components'
import Button from 'components/@common/Button'

export const UpdateButton = styled(Button)`
  padding: 4px 12px;
  box-sizing: border-box;
  margin-top: 2em;
`
